var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "11.31 6.83 83.38 87.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7579 53.1285C19.1304 41.2662 20.3166 35.3349 24.2363 31.5148C24.9607 30.8088 25.7445 30.1663 26.5789 29.5944C31.0935 26.5 37.1422 26.5 49.2396 26.5H56.7608C68.8585 26.5 74.9071 26.5 79.4218 29.5944C80.2561 30.1663 81.0396 30.8088 81.7644 31.5148C85.6838 35.3349 86.8701 41.2662 89.2427 53.1285C92.6488 70.1592 94.3519 78.6745 90.4312 84.7086C89.7215 85.8013 88.8929 86.8118 87.961 87.7221C82.8129 92.75 74.1289 92.75 56.7608 92.75H49.2396C31.8716 92.75 23.1877 92.75 18.0397 87.7221C17.1076 86.8118 16.279 85.8013 15.5692 84.7086C11.6487 78.6745 13.3518 70.1592 16.7579 53.1285Z",
    fill: "#f08417",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 26.5V22.0833C39.75 14.7656 45.682 8.83331 53 8.83331C60.318 8.83331 66.25 14.7656 66.25 22.0833V26.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5048 66.25C42.3237 71.3963 47.2318 75.0833 53.0009 75.0833C58.7699 75.0833 63.6782 71.3963 65.497 66.25",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfPickup);
export default __webpack_public_path__ + "static/media/self-pickup.9f85b6391754dbef7103c64af965bfc3.svg";
export { ForwardRef as ReactComponent };